module.exports = __webpack_public_path__ + "img/CQ(2).d0139df9.jpg";